import { $inject } from "../utils/di-container";
import { LoggerService } from "./logger.service";
import { BadgeService } from "./badge.service";
import { ResponsivenessService } from "./responsiveness.service";

export class ExternalControlService {

  /** @type {LoggerService} */
  _logger;

  [$inject](obtain) {
    this._logger = obtain(LoggerService);
    this._badgeService = obtain(BadgeService);
    this._responsivenessService = obtain(ResponsivenessService);
  }

  setMetadata(badgeMeta, badgeInfo) {
    this._badgeService.deactivateAll('metadata-change/external');
    if (badgeMeta) {
      this._badgeService.initialize(badgeMeta, badgeInfo, this._responsivenessService.platform);
    }
  }

  checkPlaceholder(placeholder) {
    return this._badgeService.checkPlaceholder(placeholder);
  }

}